import { useParams } from 'react-router-dom';
import { useGetProductFullView } from './product-full/hooks';

export const useProductFullView = (props = {}) => {
  const { productId } = props;

  const { productFull, handleRefetchProductFullView } = useGetProductFullView({
    productId,
  });

  const reloadProductFullView = () => {
    if (!productId) return;
    handleRefetchProductFullView();
  };

  return { reloadProductFullView, productFull };
};

export const useSafeProductIdParam = () => {
  const { id: _id, productId: _productId } = useParams();
  const id = _id || _productId;

  return { id };
};
